import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class CdekSuggestCitiesRequestQuery
*  Query params for operation "CdekSuggestCities"
*/
export class CdekSuggestCitiesRequestQuery extends ActiveModel {

/**
  * Name
  * Наименование населенного пункта СДЭК (поисковый запрос)<br>
  */
  @ActiveField()
  Name?: string


/**
  * CountryCode
  * Код страны в формате ISO_3166-1_alpha-2<br>
  */
  @ActiveField()
  CountryCode?: string
}
